import { render, staticRenderFns } from "./IntangibleAngel.vue?vue&type=template&id=479f23f6&scoped=true&"
import script from "./IntangibleAngel.vue?vue&type=script&lang=js&"
export * from "./IntangibleAngel.vue?vue&type=script&lang=js&"
import style0 from "./IntangibleAngel.vue?vue&type=style&index=0&id=479f23f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f23f6",
  null
  
)

export default component.exports